import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { SitePreviewThumb } from './SiteLibraryCard';

export default function TemplateLibraryCard({
  template,
  isAdmin,
  busyId,
  onPreview,
  onUse,
  onDelete,
}) {
  const isBusy = busyId === template._id;
  const sectionCount = template.sections?.length ?? 0;
  const componentCount =
    (template.sections || []).reduce((n, s) => n + (s.components?.length || 0), 0) +
    (template.pageMenu ? 1 : 0);
  const description =
    template.templateDescription || template.description || '';

  return (
    <article className="group flex flex-col rounded-2xl border border-border/80 bg-card shadow-elevation-1 overflow-hidden transition-all duration-200 hover:shadow-elevation-2 hover:border-primary/25 hover:-translate-y-0.5">
      <button
        type="button"
        className="block relative w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        onClick={() => onPreview(template)}
      >
        <SitePreviewThumb site={template} />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full backdrop-blur-md shadow-sm bg-violet-500/90 text-white">
            Template
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/20 transition-colors">
          <span className="opacity-0 group-hover:opacity-100 transition-opacity inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background/95 text-sm font-medium shadow-lg">
            <Icon name="Eye" size={15} />
            Aperçu
          </span>
        </div>
      </button>

      <div className="flex flex-col flex-1 p-4 gap-3">
        <div className="min-w-0">
          <h2 className="font-semibold text-foreground truncate text-base leading-snug">
            {template.title || 'Sans titre'}
          </h2>
          {description ? (
            <p className="text-xs text-muted-foreground mt-1 line-clamp-3">{description}</p>
          ) : (
            <p className="text-xs text-muted-foreground/50 italic mt-1">Aucune description</p>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground">
          <span className="inline-flex items-center gap-1">
            <Icon name="Layers" size={12} />
            {sectionCount} section{sectionCount !== 1 ? 's' : ''}
          </span>
          <span className="inline-flex items-center gap-1">
            <Icon name="LayoutGrid" size={12} />
            {componentCount} bloc{componentCount !== 1 ? 's' : ''}
          </span>
        </div>

        <div className="flex flex-wrap gap-2 pt-1 mt-auto border-t border-border/60">
          <Button
            size="sm"
            className="flex-1 min-w-[88px]"
            disabled={isBusy}
            onClick={() => onUse(template)}
          >
            <Icon name="Copy" size={14} className="mr-1.5" />
            {isBusy ? '…' : 'Utiliser'}
          </Button>

          <Button
            size="sm"
            variant="outline"
            className="flex-1 min-w-[88px]"
            onClick={() => onPreview(template)}
          >
            <Icon name="Eye" size={14} className="mr-1.5" />
            Aperçu
          </Button>

          {isAdmin ? (
            <>
              <Link to={`/web-creator/edit/${template._id}`} className="flex-1 min-w-[88px]">
                <Button size="sm" variant="outline" className="w-full">
                  <Icon name="Pencil" size={14} className="mr-1.5" />
                  Éditer
                </Button>
              </Link>
              <Button
                size="sm"
                variant="ghost"
                className="text-destructive hover:text-destructive hover:bg-destructive/10 px-2"
                title="Supprimer le template"
                disabled={isBusy}
                onClick={() => onDelete(template._id)}
              >
                <Icon name="Trash2" size={15} />
              </Button>
            </>
          ) : null}
        </div>
      </div>
    </article>
  );
}
